import React from 'react'

export default ({ node }) => (
  <div>
    <div>{node.extras.message}</div>
  </div>
)



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/SayPlay/SayPlayDisplay.jsx